import { useEffect, useState } from 'react';

import style from './style.module.css';
import 'rc-slider/assets/index.css';
import './style.css';
import Select from 'react-select';

import Checkbox from '@components/Checkbox';

const CalculatorMM = ({ onChangeInfo}) => {
    let [price, setPrice] = useState(0);
    let [isExpressBoost, setIsExpressBoost] = useState(false);
    let [currentRankPrice, setCurrentRankPrice] = useState(120);
    let [winsCount, setWinsCount] = useState(1);
    let [boostModePercent, setBoostModePercent] = useState(1);

    const data = {
        selectors: [
            {
                name: 'current-rank',
                label: 'Текущий ранг',
                options : [
                    { value: 120, label: '0-4999' },
                    { value: 170, label: '5000-9999' },
                    { value: 250, label: '10000-14999' },
                    { value: 350, label: '15000-19999' },
                    { value: 550, label: '20000-24999' },
                    { value: 900, label: '25000-29999' },
                    { value: 1500, label: '30000-35000' },
                  ],
            },
            {
                name: 'wins-count',
                label: 'Кол-во побед',
                options : [
                    { value: 1, label: '+1 победа' },
                    { value: 2, label: '+2 победы' },
                    { value: 3, label: '+3 победы' },
                    { value: 4, label: '+4 победы' },
                    { value: 5, label: '+5 побед' },
                    { value: 6, label: '+6 побед' },
                    { value: 7, label: '+7 побед' },
                    { value: 8, label: '+8 побед' },
                    { value: 9, label: '+9 побед' },
                    { value: 10, label: '+10 побед' },
                    { value: 20, label: '+20 побед' },
                  ],
            },
            {
                name: 'boost-type',
                label: 'Тип буста',
                options : [
                    { value: 1, label: 'Соло' },
                    { value: 1.5, label: 'Пати' },
                  ],
            }
        ],
        checkboxes: [
            {
                id: 'express-boost',
                label: 'Экспресс буст (+50%) (скорость х2)',
                value: isExpressBoost,
            },
        ]
    }
    
    const onChangeSelect = (option, actionMeta) => {
        if(actionMeta.name === 'current-rank') {
            setCurrentRankPrice(option.value);
        }
        if(actionMeta.name === 'wins-count') {
            setWinsCount(option.value);
        }
        if(actionMeta.name === 'boost-type') {
            setBoostModePercent(option.value);
        }
    }

    const onChangeCheckbox = (id) => {
        if (id === 'express-boost') setIsExpressBoost(!isExpressBoost);
    }

    const calculate = () => {
        const expressMultiplier = isExpressBoost ? 1.5 : 1;
        const newPrice = winsCount * currentRankPrice * boostModePercent * expressMultiplier;
        setPrice(Math.ceil(newPrice));
        return newPrice;
    }

    useEffect(()=>{
        onChangeInfo({
            from: data.selectors[0].options.filter((option)=> option.value === currentRankPrice)[0].label,
            to: winsCount,
            price: calculate(),
            lobby: boostModePercent !== 1,
            express: isExpressBoost,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isExpressBoost, boostModePercent, winsCount, currentRankPrice]);

    useEffect(()=>{
        onChangeInfo({
            from: data.selectors[0].options.filter((option)=> option.value === currentRankPrice)[0].label,
            to: winsCount,
            price: calculate(),
            lobby: boostModePercent !== 1,
            express: isExpressBoost,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return(
        <>
            <div className={style.calculator__block}>
                <div className={style.calculator__img}>
                    <img src="/img/premier-wins.png" alt="divine boost" />
                </div>
                <div>
                    {
                        data.selectors.map((select)=>(
                            <div key={select.name}>
                                <label style={{display: 'block',color: '#fff', marginBottom: '10px', marginTop: '10px'}} id={`${select.name}-label`} htmlFor={select.name}>
                                    {select.label}
                                </label>
                                <Select
                                    aria-labelledby={`${select.name}-label`}
                                    inputId={select.name}
                                    name={select.name}
                                    defaultValue={select.options[0]}
                                    options={select.options}
                                    onChange={onChangeSelect}
                                />
                            </div>
                        ))
                    }
                    {data.checkboxes.map((checkbox)=>(
                        <div className={style.calculator__checkbox} key={checkbox.id}>
                            <Checkbox value={checkbox.value} onCheckBoxClick={onChangeCheckbox} id={checkbox.id} />
                            <span className={style.calculator__label}>
                                {checkbox.label}
                            </span>
                        </div>
                    ))}
                    <div className={style.calculator__wrapper}>
                        <span >Калибровка 3000 рублей</span>
                        <span>Калибровка в пати 4500 рублей</span>
                        <span>Чтобы сделать заказаз напишите в нашу группу <a href="https://vk.com/divineboost">VK</a></span>
                    </div>
                </div>

            </div>
            <span className={style.calculator__price}>
                Итоговая цена: <span>{price}р</span>
            </span>
        </>
    )
}

export default CalculatorMM;
